interface Edges<T> {
    edges?: ({ node?: T | null } | null)[] | null;
}

export function flatMapEdges<T>(array?: Edges<T> | null): T[] {
    if (!array?.edges) {
        return [];
    }

    return array.edges.flatMap((item) => (item?.node ? [item.node] : []));
}
